export { default } from './svg/email.svg';
